import { render, staticRenderFns } from "./UserCompany.vue?vue&type=template&id=bc82d0ec&scoped=true&"
import script from "./UserCompany.vue?vue&type=script&lang=js&"
export * from "./UserCompany.vue?vue&type=script&lang=js&"
import style0 from "./UserCompany.vue?vue&type=style&index=0&id=bc82d0ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc82d0ec",
  null
  
)

export default component.exports